interface ILogParams {
	region?: string;
	event_id?: string;
	more_info?: Record<string, any> | string;
	[key: string]: any;
}

function encodeMoreInfo(moreInfo?: Record<string, any> | string): string | undefined {
	if (!moreInfo) {
		return undefined;
	}

	const moreInfoText = typeof moreInfo === 'string' ? moreInfo : JSON.stringify(moreInfo);
	return encodeURIComponent(encodeURIComponent(moreInfoText));
}

function buildLogParams(logParams: ILogParams = {}): Record<string, any> {
	const params = { ...(logParams || {}) };
	const { region, more_info } = logParams;
	const encodedMoreInfo = encodeMoreInfo(more_info);

	if (encodedMoreInfo) {
		params.more_info = encodedMoreInfo;
	}
	if (region) {
		params.region = region;
	}

	return params;
}

/**
 * pv 页面浏览埋点的封装方法
 * more_info 按公司统一口径做两次 encode，避免特殊符号丢失。
 */
export function pvLog(logParams: ILogParams = {}): void {
	const params = buildLogParams(logParams);
	if (typeof window !== 'undefined' && typeof (window as any)._qla !== 'undefined') {
		(window as any)._qla('pv', params);
	}
}

/**
 * visible js 主动曝光的封装方法
 * more_info 按公司统一口径做两次 encode，避免特殊符号丢失。
 */
export function visibleLog(logParams: ILogParams = {}): void {
	const params = buildLogParams(logParams);
	if (typeof window !== 'undefined' && typeof (window as any)._qla !== 'undefined') {
		(window as any)._qla('visible', {
			logs: JSON.stringify([params]),
		});
	}
}

/**
 * click js 主动点击的封装方法
 * more_info 按公司统一口径做两次 encode，避免特殊符号丢失。
 */
export function clickLog(logParams: ILogParams = {}): void {
	const params = buildLogParams(logParams);
	if (typeof window !== 'undefined' && typeof (window as any)._qla !== 'undefined') {
		(window as any)._qla('click', params);
	}
}
